export enum SelectionType {
    ML = "ML",
    OU = "OU",
    HC = "HC",
    QA = "QA"
}